import React, { useState, memo } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();
export const NewOption = memo((props) => {
  const { addOption } = props;
  const initialOptionState = {
    code: '',
    name_ja: '',
    name_en: '',
    desc_ja: '',
    desc_en: ''
  }
  const [option, setOption] = useState(initialOptionState);

  const onChangeCode = e => setOption({ ...option, code: e.target.value });
  const onChangeJa = e => setOption({ ...option, name_ja: e.target.value });
  const onChangeEn = e => setOption({ ...option, name_en: e.target.value });
  const onChangeJaDesc = e => setOption({ ...option, desc_ja: e.target.value });
  const onChangeEnDesc = e => setOption({ ...option, desc_en: e.target.value });
  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onClickCreateSubmit = () => {
    if (!option.code || !option.name_ja || !option.name_en) {
      alert("※入力必須です。");
      return
    }
    var data = {item: {
        code: option.code,
        translations_attributes: [
          {locale: "ja", name: option.name_ja.trim(), description: option.desc_ja.trim()},
          {locale: "en", name: option.name_en.trim(), description: option.desc_en.trim()}
        ]
    }}

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/agent/options`, data)
    .then(resp => {
      console.log(resp.data);
      addOption(resp.data);
      notify("success", "Option successfully created!");
      setOption({
        code: '',
        name_ja: '',
        name_en: '',
        desc_ja: '',
        desc_en: ''
      });
    })
    .catch(e => {
      console.log(e.response);
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "Option create Error!");
    })
  }

  return (
    <tr>
      <td>
        <input type="number" className="form-control" placeholder="code" value={option.code} onChange={onChangeCode} />
      </td>
      <td>
          <input type="text" className="form-control" placeholder="ラベル名" value={option.name_ja} onChange={onChangeJa} />
          <input type="text" className="form-control" placeholder="備考" value={option.desc_ja} onChange={onChangeJaDesc} />
      </td>
      <td>
          <input type="text" className="form-control" placeholder="ラベル名" value={option.name_en} onChange={onChangeEn} />
          <input type="text" className="form-control" placeholder="備考" value={option.desc_en} onChange={onChangeEnDesc} />
      </td>
      <td colSpan="2">
        <button onClick={onClickCreateSubmit} className="btn btn-primary" disabled={(!option.code || !option.name_ja || !option.name_en)}>
          <i className="far fa-plus-square" /> 追加
        </button>
      </td>
    </tr>
  );
});
